import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as Svg } from '../../assets/createPanelIcon.svg';
import './icons.scss';

interface ICustomSvgIconProps extends SvgIconProps {
  ariaLabel?: string;
}

const CreatePanelIcon = (props: ICustomSvgIconProps) => {
  const {
    id,
    color,
    fontSize,
    htmlColor,
    shapeRendering,
    sx,
    titleAccess,
    viewBox,
    tabIndex,
    ariaLabel,
    onClick,
    onKeyUp,
  } = props;

  return (
    <SvgIcon
      color={color}
      fontSize={fontSize}
      htmlColor={htmlColor}
      shapeRendering={shapeRendering}
      sx={{ ...sx }}
      className='icons'
      titleAccess={titleAccess}
      viewBox={viewBox ?? '0 0 16 16'}
      component={Svg}
      onClick={onClick && onClick}
      data-testid={id}
      onKeyUp={onKeyUp && onKeyUp}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      aria-hidden={false}
    />
  );
};

export default CreatePanelIcon;
